// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__gh3KH","label":"Labeled_label__1s6_a","divider":"Labeled_divider__1z5nQ"};